module.exports = __webpack_public_path__ + "img/pc_banner_sport.15831ae4.jpeg";